import { afterNextRender, Directive, ElementRef, inject, signal } from '@angular/core';

import { VIEWPORT_BOTTOM_GAP_PX } from './menu.types';

@Directive({
  selector: '[mlFitViewport]',
  host: {
    class: 'flex flex-col',
    '[style.max-height.px]': 'maxHeight()',
    '(window:resize)': 'measure()',
  },
})
export class FitViewportDirective {
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly maxHeight = signal<number | null>(null);

  constructor() {
    afterNextRender(() => this.measure());
  }

  protected measure(): void {
    const { top } = this.host.nativeElement.getBoundingClientRect();
    this.maxHeight.set(Math.max(window.innerHeight - top - VIEWPORT_BOTTOM_GAP_PX, 0));
  }
}
